import { Box } from "@mui/material";
import { useLocation, useParams } from "react-router-dom";

import { Page } from "v2/components";
import { CampaignMonitor } from "v2/pages/Workspace/Activity/AppCampaign/Monitor/CampaignMonitor";
import { MONITORED_TYPES_BY_TEMPLATE } from "v2/pages/Workspace/Activity/AppCampaign/Monitor/CampaignTypeTabs";
import { MonitorableType } from "v2/pages/Workspace/Activity/AppCampaign/Monitor/monitor.types";
import { parseFilterParam } from "v2/pages/Workspace/Activity/AppCampaign/Monitor/monitor.utils";
import { CAMPAIGN_TYPE_LABEL } from "v2/services/contractLifecycle.service";

/** why: os tipos com monitor já estão declarados por template; a rota não mantém outra lista. */
const MONITORED_TYPES: readonly string[] = Object.values(MONITORED_TYPES_BY_TEMPLATE).flat();

export const parseMonitorable = (raw: string): MonitorableType | null =>
  MONITORED_TYPES.includes(raw) ? (raw as MonitorableType) : null;

function OrganizationMonitor({ organizationId, type }: { organizationId: string; type: MonitorableType }) {
  const { search } = useLocation();
  // why: o atalho "Ver toda a carteira" mora no CampaignMonitor, que o mostra também na visão por contrato.
  return <CampaignMonitor source={{ kind: "ORGANIZATION", organizationId }} type={type} initialFilters={parseFilterParam(search)} />;
}

/** why: visão do RH e destino do link do e-mail semanal (T11): todos os contratos do CNPJ que a sessão pode ver. */
export function OrganizationCampaignMonitor() {
  const { organizationId, type } = useParams() as { organizationId: string; type: string };
  const monitorable = parseMonitorable(type);

  if (!monitorable) {
    return (
      <Page title="Campanhas">
        <Page.Tab name="Monitor">
          <Box>Tipo de campanha sem monitor.</Box>
        </Page.Tab>
      </Page>
    );
  }
  return (
    <Page title={`Campanhas: ${CAMPAIGN_TYPE_LABEL[monitorable]}`} backRoute={`/v2/organizations/${organizationId}/workspaces`}>
      <Page.Tab name="Monitor">
        <OrganizationMonitor key={`${organizationId}|${monitorable}`} organizationId={organizationId} type={monitorable} />
      </Page.Tab>
    </Page>
  );
}
